module.exports = __webpack_public_path__ + "static/media/img1.265f4883.jpg";